import React from 'react';
import io from "socket.io-client";
import { sock_URL } from '../Screens/User/Config/Config';

export const socket = io(sock_URL, { transports: ['websocket'] });
export const SocketContext = React.createContext();

socket.on("disconnect", (reason) => {
    window.location.reload();
});